/* Iceman 2026 商品頁互動：選長度／尺寸、價格、落點線、配成一組、量手腕、耳環實際大小、加入購物車、售完時傳 LINE */
(function () {
  var LEN = {
    '16': { cm: 40, t: '16"（40cm）・貼頸', d: '貼著脖子的短鍊。細鍊單戴最俐落，疊戴放最內層。' },
    '18': { cm: 45, t: '18"（45cm）・鎖骨下方一點', d: '落在鎖骨下方一點，俐落乾淨。單戴最好看。' },
    '20': { cm: 50, t: '20"（50cm）・上胸口', d: '落在上胸口，圓領 T 外剛好露出。最多人選的長度。' },
    '22': { cm: 55, t: '22"（55cm）・接近胸口中間', d: '疊戴當外層，跟 18" 或 20" 拉出層次。' },
    '24': { cm: 60, t: '24"（60cm）・胸口中間', d: '垂到胸口，街頭感最強。配寬鬆上衣或敞開的襯衫。' }
  };
  // 官網手鍊尺寸表：尺寸 → 適合手圍（cm）
  var FIT = { '6': [14, 15], '6.5': [15.5, 16], '7': [16.5, 17], '7.5': [17.5, 18.5], '8': [19, 19.5], '8.5': [20.5, 21], '9': [22, 22.5] };
  var CHART = ['6', '6.5', '7', '7.5', '8', '8.5', '9'];
  // 手圍 → 尺寸表上的尺寸：落在哪個範圍就是哪個；卡在兩個尺寸中間選大的（小的會戴不進去）；比 9" 還粗＝null
  function chartSize(w) { for (var i = 0; i < CHART.length; i++) { if (w <= FIT[CHART[i]][1]) return CHART[i]; } return null; }
  // 這款有的尺寸裡（不管有沒有貨）戴得進去的最小那個；都太小＝最大那個（over＝可能太緊）
  function pickSize(w, keys) {
    keys = keys.filter(function (k) { return FIT[k]; }).sort(function (a, b) { return +a - +b; });
    if (!keys.length) return null;
    var cs = chartSize(w), hit = cs ? keys.filter(function (k) { return +k >= +cs; })[0] : null;
    if (!hit) return { key: keys[keys.length - 1], chart: cs, over: true, exact: false, first: false };
    return { key: hit, chart: cs, over: false, exact: hit === cs, first: hit === keys[0] };
  }
  try { localStorage.removeItem('icm_wrist'); } catch (e) { /* 舊版曾經跨頁記住手圍，清掉 */ }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var PATHS = {
    '16': 'M 138.1 368.0 C 189.3 465.1 327.9 640.0 455.0 640.0 C 582.1 640.0 726.1 465.1 783.7 368.0',
    '18': 'M 125.7 368.0 C 162.3 524.6 315.6 735.0 455.0 735.0 C 594.4 735.0 754.1 524.6 797.9 368.0',
    '20': 'M 121.5 368.0 C 148.4 630.0 309.2 860.0 455.0 860.0 C 600.8 860.0 768.7 630.0 803.1 368.0',
    '22': 'M 120.1 368.0 C 142.3 746.2 306.4 985.0 455.0 985.0 C 603.6 985.0 775.1 746.2 804.9 368.0',
    '24': 'M 119.5 368.0 C 139.1 856.6 305.0 1100.0 455.0 1100.0 C 605.0 1100.0 778.3 856.6 805.7 368.0'
  };
  var LABEL_Y = { '16': 470, '18': 560, '20': 650, '22': 740, '24': 830 };   // 右側一欄、間距一樣，每個壓在自己那條線上
  var FRACS = [['1/5', 0.2], ['1/4', 0.25], ['1/3', 1 / 3], ['2/5', 0.4], ['1/2', 0.5], ['3/5', 0.6], ['2/3', 2 / 3], ['3/4', 0.75], ['4/5', 0.8], ['差不多一樣', 1]];

  function money(c) { return 'NT$' + Math.round(c / 100).toLocaleString('en-US'); }
  function keyOf(v) { return v ? String(v).split('（')[0].replace(/["“”]/g, '').trim() : ''; }
  function disp(v) { return v ? String(v).replace(/[“”]/g, '"') : ''; }
  function cmOf(v) { var m = String(v || '').match(/（(.+?)）/); return m ? m[1] : ''; }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    var P = JSON.parse($(root, '[data-product-json]').textContent);
    var X = JSON.parse($(root, '[data-extra-json]').textContent);
    var kind = X.kind, hot = root.dataset.hot || '20';
    var nOpt = P.options.length;
    var hasOpts = !(P.variants.length === 1 && P.variants[0].title === 'Default Title');
    var sizeIdx = kind === 'bracelet' ? 0 : kind === 'set' ? 1 : -1; // 手鍊尺寸在第幾個選項
    var lenIdx = (kind === 'necklace' || kind === 'set') ? 0 : -1;    // 項鍊長度在第幾個選項
    var optVals = [];
    for (var oi = 0; oi < nOpt; oi++) optVals.push(uniq(P.variants.map(function (v) { return v.options[oi]; })));
    var sel = [];
    for (var i = 0; i < nOpt; i++) sel.push(null);
    var st = { setOn: false, setPick: null, wrist: 16, touched: false, rec: '', recLab: '' };   // touched＝客人在這頁按過 − ＋（量過）

    function matches(v, s) { for (var k = 0; k < nOpt; k++) { if (s[k] !== null && v.options[k] !== s[k]) return false; } return true; }
    function canPick(idx, value) {
      var s = sel.slice(); s[idx] = value;
      return P.variants.some(function (v) { return v.available && matches(v, s); });
    }
    function anyAvail(idx, value) { return P.variants.some(function (v) { return v.available && v.options[idx] === value; }); }
    function variant() {
      if (!hasOpts) return P.variants[0];
      if (sel.indexOf(null) >= 0) return null;
      return P.variants.find(function (v) { return matches(v, sel); }) || null;
    }

    // 預設選擇：網址有 ?variant= 就用它；項鍊預選最多人選的長度；手鍊尺寸不預選（先量手腕）
    var pre = X.selectedVariant ? P.variants.find(function (v) { return v.id === X.selectedVariant; }) : null;
    if (pre && hasOpts) sel = pre.options.slice();
    else if (hasOpts) {
      if (lenIdx === 0) {
        var order = [hot, '20', '18', '22', '24', '16'];
        var vals = optVals[0];
        for (var o = 0; o < order.length && sel[0] === null; o++) {
          var hit = vals.find(function (x) { return keyOf(x) === order[o] && anyAvail(0, x); });
          if (hit) sel[0] = hit;
        }
        if (sel[0] === null) sel[0] = vals[0];
      } else if (sizeIdx < 0) {
        for (var q = 0; q < nOpt; q++) { var fv = P.variants.find(function (v) { return v.available; }) || P.variants[0]; sel[q] = fv.options[q]; }
      }
    }
    function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

    // 配成一組
    var cp = X.counterpart, sp = X.setProduct, setEl = $(root, '[data-set]');
    if (cp && sp && setEl) {
      if (kind === 'necklace') {
        var b7 = cp.variants.find(function (v) { return keyOf(v.option1) === '7' && v.available; }) || cp.variants.find(function (v) { return v.available; }) || cp.variants[0];
        st.setPick = b7.option1;
      }
    }
    function setVariant() {
      if (!cp || !sp) return null;
      var neck = kind === 'necklace' ? sel[0] : st.setPick, br = kind === 'necklace' ? st.setPick : sel[0];
      if (!neck || !br) return null;
      return sp.variants.find(function (v) { return keyOf(v.option1) === keyOf(neck) && keyOf(v.option2) === keyOf(br); }) || null;
    }
    function cpVariant() { return cp && st.setPick ? cp.variants.find(function (v) { return v.option1 === st.setPick; }) : null; }

    // ---- 畫面更新
    function render() {
      var v = variant();
      // 選項按鈕
      $$(root, '.icm-opt').forEach(function (b) {
        var idx = +b.dataset.option, val = b.dataset.value, on = sel[idx] === val, ok = canPick(idx, val);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-sold', !ok);
        var sub = b.querySelector('.icm-opt__sub'); sub.textContent = ok ? sub.dataset.sub : '已售完';
        var flag = b.querySelector('.icm-opt__flag'), ftxt = '';
        if (idx === lenIdx && keyOf(val) === hot && ok) ftxt = '最多人選';
        if (idx === sizeIdx && st.rec && keyOf(val) === st.rec) ftxt = st.recLab;
        flag.textContent = ftxt; flag.hidden = !ftxt;
        b.classList.remove('is-need');
      });
      if (sizeIdx >= 0) {
        var hint = $(root, '[data-option-hint="' + sizeIdx + '"]'), k = keyOf(sel[sizeIdx]);
        if (hint) hint.textContent = k && FIT[k] ? '適合手圍 ' + FIT[k][0] + '–' + FIT[k][1] + 'cm' : '先量手腕，或直接選';
      }
      // 價格
      var setV = setVariant(), sOn = st.setOn && setV && setV.available;
      var price = sOn ? setV.price : v ? v.price : P.price_min;
      $(root, '[data-price]').textContent = money(price) + (!v && !sOn && P.price_min !== P.price_max ? ' 起' : '');
      var cmp = $(root, '[data-compare]');
      if (cmp) cmp.hidden = !(v && v.compare_at_price > v.price);
      // 落點線
      if (lenIdx === 0) {
        var keys = optVals[0].map(keyOf), cur = keyOf(sel[0]);
        $$(root, '[data-line]').forEach(function (p) { var kk = p.dataset.line; p.classList.toggle('is-off', keys.indexOf(kk) < 0); p.classList.toggle('is-on', kk === cur); });
        $$(root, '[data-label]').forEach(function (t) { var kk = t.dataset.label; t.classList.toggle('is-off', keys.indexOf(kk) < 0); t.classList.toggle('is-on', kk === cur); });
        var L = LEN[cur], tt = $(root, '[data-tryon-title]'), td = $(root, '[data-tryon-desc]');
        if (tt && L) { tt.textContent = L.t; td.textContent = L.d; }
      }
      var note = $(root, '[data-price-note]'); if (note && (kind === 'necklace' || kind === 'bracelet')) note.textContent = disp(sel[0]);
      // 配成一組
      if (setEl) renderSet(v, setV);
      // 購物列
      var label = barLabel(v, sOn), btn = $(root, '[data-add]');
      $(root, '[data-bar-label]').textContent = label;
      $(root, '[data-bar-price]').textContent = !P.available ? '—' : money(price);
      if (!P.available) { btn.disabled = false; btn.textContent = '貨到通知我'; }
      else if (!v && !sOn) { btn.disabled = false; btn.textContent = sizeIdx >= 0 && sel[sizeIdx] === null ? '先選尺寸' : '先選長度'; }
      else if (!sOn && !v.available) { btn.disabled = true; btn.textContent = '這個選項售完'; }
      else { btn.disabled = false; btn.textContent = '加入購物車'; }
      var input = $(root, '[data-variant-input]'); if (input && v) input.value = v.id;
      if (sv) svUpdate();
    }
    function barLabel(v, sOn) {
      var c = X.colorName ? '・' + X.colorName : '';
      if (!P.available && kind !== 'earring') return kind === 'bracelet' ? X.colorName + '・目前全部售完' : (X.colorName ? X.colorName + ' ' : '') + (X.wseg || X.name) + '・目前全部售完';
      if (sOn) { var n = kind === 'necklace' ? sel[0] : st.setPick, b = kind === 'necklace' ? st.setPick : sel[0]; return '組合：' + keyOf(n) + '" 項鍊＋' + keyOf(b) + '" 手鍊' + c; }
      var stone = $(root, '.icm-size.is-on[data-stone-mm]'), ser = $(root, '[data-series]');
      if (kind === 'earring' && stone && ser) return ser.dataset.series + ' ' + stone.dataset.stoneLabel + '・一對・直徑 ' + stone.dataset.stoneMm + 'mm';
      if (!hasOpts) return X.name + c + (kind === 'earring' ? '・一對' : '');
      if (kind === 'set') return (sel[0] ? keyOf(sel[0]) + '" 項鍊' : '項鍊長度未選') + '＋' + (sel[1] ? keyOf(sel[1]) + '" 手鍊' : '手鍊尺寸未選') + c;
      if (kind === 'bracelet' && !sel[0]) return '還沒選尺寸';
      var s0 = sel[0] ? disp(sel[0]) : '長度未選';
      return (X.wseg || X.name) + '・' + s0 + c;
    }
    function renderSet(v, setV) {
      var cpv = cpVariant(), title = $(root, '[data-set-title]'), pr = $(root, '[data-set-price]'), sep = $(root, '[data-set-sep]'), note = $(root, '[data-set-note]'), tg = $(root, '[data-set-toggle]');
      if (kind === 'necklace') title.textContent = '加同款 ' + X.wseg + ' 手鍊（' + keyOf(st.setPick) + '"）';
      else title.textContent = '加同款 ' + X.wseg + ' 項鍊' + (st.setPick ? '（' + keyOf(st.setPick) + '"）' : '');
      var ok = !!(setV && setV.available && v);
      if (setV) {
        pr.textContent = money(setV.price);
        var sepN = (v ? v.price : 0) + (cpv ? cpv.price : 0);
        sep.textContent = v && cpv && sepN > setV.price ? money(sepN) : '';
        note.textContent = !v ? (kind === 'necklace' ? '先選項鍊長度' : '先選手鍊尺寸') : setV.available ? '整組立即省 ' + money(sepN - setV.price) : '這個長度＋尺寸的組合目前缺貨';
      } else {
        var prices = sp.variants.map(function (x) { return x.price; });
        pr.textContent = money(Math.min.apply(null, prices)) + ' 起'; sep.textContent = '';
        note.textContent = kind === 'necklace' || !v ? '先選手鍊尺寸' : '選項鍊長度（疊戴可以選跟平常不同的長度）';
      }
      note.classList.toggle('is-bad', !!(setV && v && !setV.available));
      tg.disabled = !ok;
      if (!ok) st.setOn = false;
      tg.setAttribute('aria-pressed', st.setOn ? 'true' : 'false');
      tg.textContent = st.setOn ? '已選組合 ✓' : '改買組合';
      setEl.classList.toggle('is-on', st.setOn);
      // 另一件的選項
      var box = $(root, '[data-set-chips]'); box.innerHTML = '';
      var other = uniq(cp.variants.map(function (x) { return x.option1; }));
      other.forEach(function (val) {
        var neck = kind === 'necklace' ? sel[0] : val, br = kind === 'necklace' ? val : sel[0];
        var sv = sp.variants.find(function (x) { return keyOf(x.option1) === keyOf(neck) && keyOf(x.option2) === keyOf(br); });
        var avail = sv ? sv.available : cp.variants.some(function (x) { return x.option1 === val && x.available; });
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'icm-chip' + (avail ? '' : ' is-sold'); b.textContent = keyOf(val) + '"';
        b.setAttribute('aria-pressed', st.setPick === val ? 'true' : 'false');
        b.addEventListener('click', function () { st.setPick = val; render(); });
        box.appendChild(b);
      });
    }

    // ---- 事件
    $$(root, '.icm-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = +b.dataset.option, val = b.dataset.value;
        sel[idx] = val;
        // 其他選項跟這個組不起來就清掉
        for (var k = 0; k < nOpt; k++) { if (k !== idx && sel[k] !== null && !canPick(k, sel[k])) sel[k] = null; }
        render();
      });
    });
    var tg = $(root, '[data-set-toggle]');
    if (tg) tg.addEventListener('click', function () { st.setOn = !st.setOn; render(); });

    // 量手腕：先找出你真正的尺寸（不管有沒有貨），售完就老實說售完＋到貨通知；只會推大一號、而且不會太鬆的，絕不推小的
    var wr = $(root, '[data-wrist]');
    function renderWrist() {
      if (!wr || sizeIdx < 0) return;
      var all = optVals[sizeIdx].filter(function (x) { return FIT[keyOf(x)]; });
      var w = st.wrist, wt = w.toFixed(1), txt = '', use = $(root, '[data-wrist-use]'), alt = $(root, '[data-wrist-alt]');
      var wv = $(root, '[data-wrist-val]');
      wv.textContent = st.touched ? wt + ' cm' : '— cm'; wv.classList.toggle('is-ph', !st.touched);
      use.hidden = true; alt.hidden = true; st.rec = ''; st.recLab = '';
      var pk = st.touched ? pickSize(w, all.map(keyOf)) : null;
      if (!st.touched) txt = '還沒量：用軟尺量手腕一圈，按 − ＋ 輸入（從 16cm 開始調），就會幫你挑尺寸。';
      else if (!pk) txt = '這款沒有可以對照的尺寸，歡迎傳 LINE 問我們。';
      else {
        var k = pk.key, f = FIT[k], val = all.find(function (x) { return keyOf(x) === k; }), ok = anyAvail(sizeIdx, val);
        if (pk.over) txt = '手圍 ' + wt + 'cm 比這款最大的 ' + k + '"（適合 ' + f[0] + '–' + f[1] + 'cm）還粗，可能會太緊，建議再量一次或傳 LINE 問我們。';
        else if (pk.exact) txt = '手圍 ' + wt + 'cm → 你的尺寸是 ' + k + '"（適合手圍 ' + f[0] + '–' + f[1] + 'cm）。';
        else if (pk.first) txt = '手圍 ' + wt + 'cm → 這款最小是 ' + k + '"，戴起來會比較鬆。';
        else txt = '手圍 ' + wt + 'cm → 這款沒有 ' + pk.chart + '"，建議 ' + k + '"，會稍微鬆一點。';
        if (pk.over) {                                   // 比最大的還粗：不推任何尺寸（可能扣不起來），請客人問我們
          use.hidden = false; use.textContent = '傳 LINE 問我們適合的尺寸';
          use.onclick = function () { window.open(X.lineUrl || 'https://lin.ee/N0h9cUz', '_blank', 'noopener'); };
          $(root, '[data-wrist-rec]').textContent = txt; render(); if (sv) svUpdate(); return;
        }
        st.rec = k; st.recLab = pk.exact ? '你的尺寸' : '建議';
        if (ok) {
          use.hidden = sel[sizeIdx] === val;
          use.textContent = '選 ' + k + '"（' + st.recLab + '）';
          use.onclick = function () { sel[sizeIdx] = val; render(); renderWrist(); };
        } else {
          txt += k + '" 目前售完。';
          use.hidden = false; use.textContent = k + '" 到貨通知我（傳 LINE）';
          use.onclick = function () { window.open(X.lineUrl || 'https://lin.ee/N0h9cUz', '_blank', 'noopener'); };
          // 大一號以上、手鍊比手腕長 3cm 以內（再大就太鬆了）而且有貨的
          var big = all.filter(function (x) { return +keyOf(x) > +k && anyAvail(sizeIdx, x) && +keyOf(x) * 2.54 - w <= 3; })
            .sort(function (a, b) { return +keyOf(a) - +keyOf(b); })[0];
          if (big) {
            txt += '想現在買可以選 ' + keyOf(big) + '"，會鬆一點。';
            alt.hidden = sel[sizeIdx] === big; alt.textContent = '改選 ' + keyOf(big) + '"（會鬆一點）';
            alt.onclick = function () { sel[sizeIdx] = big; render(); renderWrist(); };
          } else txt += '其他有貨的尺寸都會太鬆，建議等補貨。';
        }
      }
      $(root, '[data-wrist-rec]').textContent = txt;
      render();
      if (sv) svUpdate();
    }
    if (wr) {                                           // 第一次按 − 或 ＋ 都先出現 16cm，之後再往下／往上調
      $$(wr, '[data-wrist-step]').forEach(function (b) {
        b.addEventListener('click', function () { st.wrist = st.touched ? Math.min(23, Math.max(13, st.wrist + parseFloat(b.dataset.wristStep))) : 16; st.touched = true; renderWrist(); });
      });
    }

    // 配成一組：點縮圖或「看細節」→ 另一件的照片、材質、長度落點／尺寸，選了直接同步到組合
    var sv = null, otherIsNeck = kind === 'bracelet';
    function cpName() { var t = String(cp.title || ''), n = t.indexOf(' - ') >= 0 ? t.split(' - ').slice(1).join(' - ') : t; return n.replace(/\s*[（(][^）)]*[）)]\s*$/, ''); }
    function cpField(key) {
      var ta = document.createElement('textarea');
      ta.innerHTML = String(cp.description || '').replace(/<\/(p|li|div|h\d)>|<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '');
      var line = ta.value.split('\n').map(function (x) { return x.trim(); }).filter(function (x) { return x.indexOf(key + '：') === 0 || x.indexOf(key + ':') === 0; })[0];
      return line ? line.slice(key.length + 1).trim() : '';
    }
    function pic(u, wd) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + wd; }
    function tryonSVG(keys) {
      return '<svg viewBox="0 0 900 1125" aria-hidden="true">' +
        Object.keys(PATHS).map(function (k) { return '<path data-line="' + k + '" d="' + PATHS[k] + '"' + (keys.indexOf(k) < 0 ? ' class="is-off"' : '') + '/>'; }).join('') +
        Object.keys(LABEL_Y).map(function (k) { return '<g class="icm-tl' + (keys.indexOf(k) < 0 ? ' is-off' : '') + '" data-label="' + k + '" transform="translate(710 ' + LABEL_Y[k] + ')"><rect x="-54" y="-26" width="108" height="52" rx="26"/><text y="12">' + k + '"</text></g>'; }).join('') + '</svg>';
    }
    function svOpen() {
      if (!cp || !sp || sv) return;
      var pics = (cp.images || []).filter(function (u) { return !/packaging/i.test(u); });
      if (!pics.length && cp.featured_image) pics = [cp.featured_image];
      var keys = uniq(cp.variants.map(function (x) { return keyOf(x.option1); })), mat = cpField('材質'), nm = cpName() + (X.colorName ? '・' + X.colorName : '');
      var el = document.createElement('div');
      el.className = 'icm icm-sv'; el.setAttribute('data-icm-overlay', '');
      el.innerHTML = '<div class="icm-sv__card" role="dialog" aria-modal="true" aria-label="' + esc(nm) + '">' +
        '<div class="icm-sv__h"><b>配成一組・同款' + (otherIsNeck ? '項鍊' : '手鍊') + '</b><button type="button" class="icm-sv__x" data-sv-x aria-label="關閉">×</button></div>' +
        '<div class="icm-sv__scroll"><div class="icm-sv__gal"><div class="icm-sv__track" data-sv-track>' +
          pics.map(function (u, i) { return '<img src="' + esc(pic(u, 900)) + '" alt="' + esc(nm) + '・第 ' + (i + 1) + ' 張"' + (i > 1 ? ' loading="lazy"' : '') + '>'; }).join('') + '</div>' +
          (pics.length > 1 ? '<span class="icm-sv__n" data-sv-n>1 / ' + pics.length + '</span>' : '') + '</div>' +
        '<div class="icm-sv__info"><div class="icm-sv__name">' + esc(nm) + '</div><div class="icm-sv__price" data-sv-price></div>' +
          (mat ? '<p class="icm-sv__mat">材質：' + esc(mat) + '</p>' : '') +
          '<div class="icm-sv__lab">' + (otherIsNeck ? '項鍊長度' : '手鍊尺寸') + '</div><div class="icm-sv__chips" data-sv-chips></div><p class="icm-sv__hint" data-sv-hint></p>' +
          (otherIsNeck ? '<div class="icm-sv__try"><div class="icm-sv__tl">戴上會落在哪</div><div class="icm-tryon__img">' +
            (cp.featured_image ? '<img src="' + esc(pic(cp.featured_image, 900)) + '" alt="模特兒配戴示意，標出各長度的落點" loading="lazy">' : '') + tryonSVG(keys) +
            '</div><div class="icm-sv__tt" data-sv-tt></div><p class="icm-sv__td" data-sv-td></p><p class="icm-sv__note">實線是你選的長度，虛線是其他長度。位置為示意，依身形略有不同。</p></div>' : '') +
          '<a class="icm-sv__link" href="' + esc((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + cp.handle) + '">看完整商品頁 ›</a></div></div>' +
        '<div class="icm-sv__f"><div class="icm-sv__sum" data-sv-sum></div><button type="button" class="icm-btn icm-btn--primary icm-sv__go" data-sv-go></button></div></div>';
      document.body.appendChild(el);
      document.documentElement.classList.add('icm-lock');
      sv = { el: el, last: document.activeElement };
      el.addEventListener('click', function (e) {
        if (e.target === el || e.target.closest('[data-sv-x]')) { svClose(); return; }
        var c = e.target.closest('[data-sv-pick]');
        if (c) { st.setPick = c.getAttribute('data-sv-pick'); render(); return; }
        if (e.target.closest('[data-sv-go]')) {
          var v = variant(), setV = setVariant();
          if (!v) { svClose(); var blk = $(root, '#icm-opt-' + (sizeIdx >= 0 ? sizeIdx : 0)); if (blk) { blk.scrollIntoView({ behavior: 'smooth', block: 'center' }); $$(blk, '.icm-opt').forEach(function (b) { b.classList.add('is-need'); }); } return; }
          if (setV && setV.available) { st.setOn = true; render(); svClose(); }
        }
      });
      var tr = el.querySelector('[data-sv-track]'), cnt = el.querySelector('[data-sv-n]');
      if (tr && cnt) tr.addEventListener('scroll', function () {        // 手機一張佔 78%（露出下一張），用一張的寬度算第幾張
        var one = (tr.firstElementChild ? tr.firstElementChild.offsetWidth : tr.clientWidth) + 8;
        cnt.textContent = Math.min(pics.length, Math.round(tr.scrollLeft / (one || 1)) + 1) + ' / ' + pics.length;
      }, { passive: true });
      svUpdate();
      el.querySelector('[data-sv-x]').focus();
    }
    function svClose() {
      if (!sv) return;
      sv.el.remove(); document.documentElement.classList.remove('icm-lock');
      var last = sv.last; sv = null;
      if (last && last.focus) last.focus();
    }
    document.addEventListener('keydown', function (e) { if (sv && e.key === 'Escape') svClose(); });
    function svUpdate() {
      if (!sv) return;
      var el = sv.el, v = variant(), setV = setVariant(), cpv = cpVariant(), cur = keyOf(st.setPick);
      var opts = uniq(cp.variants.map(function (x) { return x.option1; }));
      el.querySelector('[data-sv-price]').textContent = '單買 ' + (cpv ? money(cpv.price) : money(cp.price_min) + (cp.price_min !== cp.price_max ? ' 起' : ''));
      el.querySelector('[data-sv-chips]').innerHTML = opts.map(function (val) {
        var neck = kind === 'necklace' ? sel[0] : val, br = kind === 'necklace' ? val : sel[0];
        var x = sp.variants.find(function (z) { return keyOf(z.option1) === keyOf(neck) && keyOf(z.option2) === keyOf(br); });
        var ok = x ? x.available : cp.variants.some(function (z) { return z.option1 === val && z.available; });
        return '<button type="button" class="icm-chip' + (ok ? '' : ' is-sold') + '" data-sv-pick="' + esc(val) + '" aria-pressed="' + (st.setPick === val) + '">' + esc(keyOf(val)) + '"</button>';
      }).join('');
      var hint = '';
      if (otherIsNeck) {
        var L = LEN[cur];
        hint = cur ? '' : '選一個長度，下面的圖會標出落點';
        $$(el, '[data-line]').forEach(function (pth) { pth.classList.toggle('is-on', pth.getAttribute('data-line') === cur); });
        $$(el, '.icm-tl').forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-label') === cur); });
        el.querySelector('[data-sv-tt]').textContent = L ? L.t : '';
        el.querySelector('[data-sv-td]').textContent = L ? L.d : '';
      } else {
        var f = FIT[cur], pk = st.touched ? pickSize(st.wrist, opts.map(keyOf)) : null;
        hint = f ? '適合手圍 ' + f[0] + '–' + f[1] + 'cm' : '';
        if (pk && !pk.over) hint += (hint ? '・' : '') + '你的手圍 ' + st.wrist.toFixed(1) + 'cm → ' + (pk.exact ? '你的尺寸 ' : '建議 ') + pk.key + '"';
      }
      var hn = el.querySelector('[data-sv-hint]'); hn.textContent = hint; hn.hidden = !hint;
      var sum = el.querySelector('[data-sv-sum]'), go = el.querySelector('[data-sv-go]');
      go.disabled = false;
      if (!v) {
        sum.innerHTML = '組合價<b>' + money(Math.min.apply(null, sp.variants.map(function (z) { return z.price; }))) + ' 起</b>';
        go.textContent = kind === 'necklace' ? '先選你的項鍊長度' : '先選你的手鍊尺寸';
      } else if (!setV) {
        sum.innerHTML = '組合價<b>' + money(Math.min.apply(null, sp.variants.map(function (z) { return z.price; }))) + ' 起</b>';
        go.textContent = otherIsNeck ? '先選項鍊長度' : '先選手鍊尺寸'; go.disabled = true;
      } else {
        var sepN = v.price + (cpv ? cpv.price : 0);
        sum.innerHTML = '組合價<b>' + money(setV.price) + (sepN > setV.price ? ' <s>' + money(sepN) + '</s>' : '') + '</b>' + (sepN > setV.price ? '<em>整組立即省 ' + money(sepN - setV.price) + '</em>' : '');
        if (!setV.available) { go.textContent = '這個組合目前缺貨'; go.disabled = true; }
        else go.textContent = st.setOn ? '已選組合 ✓' : '改買組合';
      }
    }
    $$(root, '[data-set-view]').forEach(function (b) { b.addEventListener('click', svOpen); });

    // 耳環實際大小
    var svg = $(root, '[data-scale]');
    if (svg) drawScale(root, svg);

    // 相簿點點
    var track = $(root, '[data-gal-track]'), dotsBox = $(root, '[data-gal-dots]'), count = $(root, '[data-gal-count]');
    if (track && dotsBox) {
      var n = track.children.length;
      for (var d = 0; d < n; d++) { var sp2 = document.createElement('span'); if (d === 0) sp2.className = 'is-on'; dotsBox.appendChild(sp2); }
      if (count) count.textContent = '1 / ' + n;
      track.addEventListener('scroll', function () {
        var gi = Math.round(track.scrollLeft / (track.clientWidth || 1));
        Array.prototype.forEach.call(dotsBox.children, function (s, i) { s.className = i === gi ? 'is-on' : ''; });
        if (count) count.textContent = (gi + 1) + ' / ' + n;
      }, { passive: true });
    }

    // 加入購物車
    var addBtn = $(root, '[data-add]');
    addBtn.addEventListener('click', function () {
      if (!P.available) { var ln = $(root, '.icm-line-btn'); if (ln) window.open(ln.href, '_blank', 'noopener'); return; } // 貨到通知＝傳 LINE
      var v = variant(), setV = setVariant(), sOn = st.setOn && setV && setV.available;
      if (!sOn && !v) {
        var need = sizeIdx >= 0 && sel[sizeIdx] === null ? sizeIdx : sel.indexOf(null);
        var blk = $(root, '#icm-opt-' + need);
        if (blk) { blk.scrollIntoView({ behavior: 'smooth', block: 'center' }); $$(blk, '.icm-opt').forEach(function (b) { b.classList.add('is-need'); }); }
        return;
      }
      var id = sOn ? setV.id : v.id, label = barLabel(v, sOn);
      addBtn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) { toast(res.j.description || '加入失敗，請再試一次', false); return; }
          toast('已加入購物車：' + label, true);
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.setAttribute('data-header-cart-count', cart.item_count); el.textContent = cart.item_count; });
            document.querySelectorAll('[data-header-cart-full]').forEach(function (el) { el.setAttribute('data-header-cart-full', cart.item_count > 0 ? 'true' : 'false'); });
            document.dispatchEvent(new CustomEvent('icm:cart:updated', { detail: cart }));
          });
        }).catch(function () { addBtn.disabled = false; toast('網路有點慢，請再試一次', false); });
    });
    var toastEl = $(root, '[data-toast]'), toastTimer;
    function toast(text, showLink) {
      clearTimeout(toastTimer);
      $(toastEl, '[data-toast-text]').textContent = text;
      toastEl.querySelector('a').hidden = !showLink;
      toastEl.hidden = false;
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, 3200);
    }

    render();
    renderWrist();
  }

  function drawScale(root, svg) {
    var NS = 'http://www.w3.org/2000/svg', size = svg.dataset.size || '', hoop = svg.dataset.hoop === '1', color = svg.dataset.color;
    function el(tag, attrs, text) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (text) e.textContent = text; svg.appendChild(e); return e; }
    el('circle', { cx: 70, cy: 62, r: 50, fill: '#f1efe8', stroke: '#b9b3a2', 'stroke-width': 1.5 });
    el('text', { x: 70, y: 66, fill: '#6b6555', 'font-size': 12, 'text-anchor': 'middle' }, '1 元硬幣');
    el('text', { x: 70, y: 124, fill: '#6b6555', 'font-size': 11, 'text-anchor': 'middle' }, '直徑 20mm');
    var two = size.match(/(\d+(?:\.\d+)?)\s*mm\s*[×xX＊*]\s*(\d+(?:\.\d+)?)/), dia = size.match(/(\d+(?:\.\d+)?)\s*mm/);
    var ring = color === 'gold' ? '#c9a24a' : '#a9aeb6', text = '', frac = function (mm) { var r = mm / 20, best = FRACS[0]; FRACS.forEach(function (f) { if (Math.abs(f[1] - r) < Math.abs(best[1] - r)) best = f; }); return best[0]; };
    var group = Array.prototype.slice.call(root.querySelectorAll('[data-stone-mm]'));
    if (group.length > 1) {
      var xs = [170, 235, 305];
      group.forEach(function (g, i) {
        var mm = parseFloat(g.dataset.stoneMm), on = g.classList.contains('is-on');
        el('circle', { cx: xs[i] || 170 + i * 65, cy: 62, r: mm * 2.5, fill: '#e8ebef', stroke: on ? '#0a0a0a' : '#b8bec7', 'stroke-width': on ? 2 : 1, opacity: on ? 1 : 0.55 });
        el('text', { x: xs[i] || 170 + i * 65, y: 124, fill: '#3d3d3d', 'font-size': 11, 'text-anchor': 'middle', 'font-weight': on ? 700 : 400 }, mm + 'mm');
        if (on) text = '直徑 ' + mm + 'mm，大約是 1 元硬幣寬度的 ' + frac(mm) + '。';
      });
    } else if (two || (hoop && dia)) {
      var hgt = two ? parseFloat(two[1]) : parseFloat(dia[1]), wid = two ? parseFloat(two[2]) : parseFloat(dia[1]);
      var rx = wid * 1.25 - 2.5, ry = hgt * 1.25 - 2.5, cy = 62;
      el('ellipse', { cx: 200, cy: cy, rx: rx, ry: ry, fill: 'none', stroke: ring, 'stroke-width': 5 });
      el('path', { d: 'M' + (200 - wid * 1.25) + ' ' + (cy + hgt * 1.25 + 8) + ' V' + (cy + hgt * 1.25 + 16) + ' M' + (200 + wid * 1.25) + ' ' + (cy + hgt * 1.25 + 8) + ' V' + (cy + hgt * 1.25 + 16) + ' M' + (200 - wid * 1.25) + ' ' + (cy + hgt * 1.25 + 12) + ' H' + (200 + wid * 1.25), fill: 'none', stroke: '#8a8a8a', 'stroke-width': 1 });
      el('text', { x: 200, y: 124, fill: '#3d3d3d', 'font-size': 11, 'text-anchor': 'middle', 'font-weight': 700 }, two ? '外圈 ' + hgt + ' × ' + wid + 'mm' : '直徑 ' + hgt + 'mm');
      text = (two ? '外圈 ' + hgt + ' × ' + wid + 'mm' : '直徑 ' + hgt + 'mm') + '，大約是 1 元硬幣的 ' + frac(Math.max(hgt, wid)) + ' 大。';
    } else if (dia) {
      var mm2 = parseFloat(dia[1]);
      var defs = document.createElementNS(NS, 'defs'); defs.innerHTML = '<radialGradient id="icmGem" cx="35%" cy="30%"><stop offset="0" stop-color="#ffffff"/><stop offset=".6" stop-color="#d9dde3"/><stop offset="1" stop-color="#9aa1ab"/></radialGradient>'; svg.appendChild(defs);
      el('circle', { cx: 200, cy: 62, r: mm2 * 1.25, fill: 'url(#icmGem)', stroke: '#0a0a0a', 'stroke-width': 1.5 });
      el('text', { x: 200, y: 124, fill: '#3d3d3d', 'font-size': 11, 'text-anchor': 'middle', 'font-weight': 700 }, '直徑 ' + mm2 + 'mm');
      text = '直徑 ' + mm2 + 'mm，大約是 1 元硬幣寬度的 ' + frac(mm2) + '。';
    }
    if (text && svg.dataset.note) text += svg.dataset.note;
    svg.setAttribute('aria-label', text || '耳環尺寸和 1 元硬幣比較');
    var t = root.querySelector('[data-scale-text]'); if (t) t.textContent = text;
  }

  function boot() { document.querySelectorAll('[data-icm-product]').forEach(function (r) { if (!r.__icm) { r.__icm = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
